import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec9043ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-container f1 fv" }
const _hoisted_2 = {
  class: "fh-c",
  style: {"height":"7.31%"}
}
const _hoisted_3 = { class: "fs16 color-06 bold" }
const _hoisted_4 = {
  class: "fv",
  style: {"height":"90.69%"}
}
const _hoisted_5 = { class: "item-name fh-c" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "fs12 color-06" }
const _hoisted_8 = { class: "item-num fs16 color-08" }
const _hoisted_9 = { class: "item-compare fh-c-e" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs12 color-04" }, "较昨日", -1))
const _hoisted_11 = { class: "fh-c" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "当前会话排队人数（人）：" + _toDisplayString(_ctx.waitingNum), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waitingData, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item f1 w100 fh-c-b",
          key: index
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "icon-call",
              src: item.compare >= 0 ? require('@/assets/icon/icon-session-green.png') : require('@/assets/icon/icon-session-orange.png')
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.label), 1)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(item.value + (item.isPercentage ? '%' : '')), 1),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["compare fs14", item.compare >= 0 ? 'color-safe': 'color-warn'])
              }, _toDisplayString((item.compare >= 0 ? '+' : '') + item.compare + (item.isPercentage ? '%' : '')), 3),
              _createElementVNode("img", {
                class: "icon-arrow",
                src: item.compare >= 0 ? require('@/assets/icon/icon-session-add.png') : require('@/assets/icon/icon-session-reduce.png')
              }, null, 8, _hoisted_12)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}